import { baseApi } from './baseApi'
import { ILocation } from '../../types/locations'
import { ILocationFormParams } from '../../types/app'

export const locationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLocations: builder.query<ILocation[], void>({
      query: () => '/locations',
      providesTags: ['Locations'],
    }),
    createLocation: builder.mutation<ILocation, ILocationFormParams>({
      query: (params) => ({
        url: '/locations',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Locations'],
    }),
    deleteLocation: builder.mutation<void, string>({
      query: (id) => ({
        url: `/locations/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Locations'],
    }),
    editLocation: builder.mutation<
      ILocation,
      { params: ILocationFormParams; id: string }
    >({
      query: ({ params, id }) => ({
        url: `/locations/${id}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: ['Locations'],
    }),
  }),
})

export const {
  useGetLocationsQuery,
  useCreateLocationMutation,
  useDeleteLocationMutation,
  useEditLocationMutation,
} = locationsApi
